// removed by extract-text-webpack-plugin
module.exports = {"root":"SubscribeComplete__root--2niBO","text":"SubscribeComplete__text--xgwDB","separator":"SubscribeComplete__separator--D5ocN","signUp":"SubscribeComplete__signUp--3_e35","checkmark":"SubscribeComplete__checkmark--3gB3j","bounce":"SubscribeComplete__bounce--a82IU"};


//////////////////
// WEBPACK FOOTER
// ./src/author/components/SubscribeComplete/SubscribeComplete.css
// module id = ./src/author/components/SubscribeComplete/SubscribeComplete.css
// module chunks = 2